import { render } from "./Schema.vue?vue&type=template&id=c57200ce&scoped=true"
import script from "./Schema.vue?vue&type=script&lang=js"
export * from "./Schema.vue?vue&type=script&lang=js"

import "./Schema.vue?vue&type=style&index=0&id=c57200ce&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c57200ce"

export default script